import type { UserProfile } from '@/types/user'
import { getTuiIconById, DEFAULT_TUI_ICON } from './tuiIcons'

/**
 * Get the avatar URL for a user profile.
 * General accounts: photoURL > selected Tui icon > default Tui icon
 * Non-general accounts: photoURL only (initials shown if no photo)
 */
export function getAvatarUrl(profile: Pick<UserProfile, 'photoURL' | 'tuiIcon' | 'subscriptionTier'>): string | null {
  if (profile.photoURL) return profile.photoURL

  const tier = profile.subscriptionTier || 'general'
  if (tier !== 'general') return null // non-general show initials until they upload a photo

  if (profile.tuiIcon) {
    const icon = getTuiIconById(profile.tuiIcon)
    if (icon) return icon.path
  }
  return DEFAULT_TUI_ICON.path
}
